import { SiteFiltersStore } from "../store";

export function updateSearchString(searchString: string, store: SiteFiltersStore) {
  store.searchString = searchString;
}
